import { render, staticRenderFns } from "./appSideLeftMenuTemplate.vue?vue&type=template&id=040d7c83&"
import script from "./appSideLeftMenuTemplate.vue?vue&type=script&lang=js&"
export * from "./appSideLeftMenuTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports